exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".my_white ul li a[data-v-d7a8ac46]{color:#fff!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/RequestView.vue"],"names":[],"mappings":"AACA,mCACE,oBAAwB,CACzB","file":"RequestView.vue","sourcesContent":["\n.my_white ul li a[data-v-d7a8ac46] {\n  color: white !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7a8ac46","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/settings/RequestView.vue
// module id = 1424
// module chunks = 4